import { render, staticRenderFns } from "./PostBody.vue?vue&type=template&id=0d41f700"
import script from "./PostBody.vue?vue&type=script&lang=js"
export * from "./PostBody.vue?vue&type=script&lang=js"
import style0 from "./PostBody.vue?vue&type=style&index=0&id=0d41f700&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports